import React, { Fragment, useEffect, useRef, useState } from "react";
import {
  Grid,
  Typography,
  Card,
  CardContent,
  Avatar,
  Box,
  Rating,
  Button,
  TablePagination,
  Tooltip,
  useMediaQuery,
  TextField,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import CategorySelectDropdown from "./CategorySelect";
import SingleDatePicker from "./singleDatePicker";
import SendReceiveSelectDropdown from "./sendRecieveSelect";
import { createFeedback, getSendAndReceivedFeedbackSuperUser } from "src/services/feedbackService";
import { AppActions } from "src/store/AppReducer";
import { useDispatch } from "react-redux";
import AddTwoToneIcon from "@mui/icons-material/AddTwoTone";
import FeedbackModal from "../modals/addFeedbackModal";
import { AddFeedback } from "../interfaces/addFeedback";
import SnackBar from "src/components/SnackBar/SnackBar";
import CategorySelectMultiselectDropdown from "./categoryMultiselect";
import { DateRangePicker } from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from "moment";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import { useNavigate } from "react-router-dom";





import '../Feedback.css';


const StarRating = ({ value }) => {
  return (
    <Rating
      readOnly
      value={value}
      sx={{ fontSize: "1.5rem", color: "#fbc02d" }}
    />
  );
};


const FeedbackCard = ({
  receiver,
  sender,
  receiverImage,
  senderImage,
  createdDate,
  rating,
  category,
  description,
  receiverDesignation,
  senderDesignation,
  project,
  isExpanded,
  onToggleExpand,
  tabValue,
  status,
  handleEditClick,
  editData,
}) => {

  const isSmallScreen = useMediaQuery('(max-width:1366px)');

  const commentRef = useRef(null);
  const [showSeeMore, setShowSeeMore] = useState(false);

  useEffect(() => {
    if (commentRef.current) {
      const element = commentRef.current;
      if (isExpanded) {
        setShowSeeMore(true);
      } else {
        const isOverflowing = element.scrollHeight > element.clientHeight;
        setShowSeeMore(isOverflowing);
      }

    }
  }, [description, isExpanded]);

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        background: "rgba(98, 103, 253, 0.05)",

      }}
    >
      <CardContent>

        <Grid container alignItems="center" spacing={2} justifyContent="space-between">
          <Grid item>
            <Grid container alignItems="center" spacing={3}>
              <Grid item style={{ paddingTop: '0px' }}>
                <Typography variant="body2">
                  <b>To</b>
                </Typography>
              </Grid>
              <Grid item >
                <Avatar
                  // src={`data:image/jpeg;base64,${receiverImage}`}
                  src={process.env.PUBLIC_URL + '/img/user.png'}
                  alt={receiver}
                  sx={{ width: 30, height: 30, borderRadius: 0 }}
                />
              </Grid>
              <Grid item>
                <Tooltip title={receiver}>
                  <Typography sx={{ maxWidth: isSmallScreen ? '14ch' : 'none', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', fontWeight: 'bold' }}>
                    {receiver}
                  </Typography>
                </Tooltip>
                <Tooltip title={receiverDesignation}>
                  <Typography sx={{ maxWidth: isSmallScreen ? '14ch' : 'none', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {receiverDesignation}
                  </Typography>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>


          <Grid item>
            <Grid container alignItems="center" spacing={3}>
              <Grid item style={{ paddingTop: '0px' }}>
                <Typography variant="body2">
                  <b>From</b>
                </Typography>
              </Grid>
              <Grid item>
                <Avatar
                  // src={`data:image/jpeg;base64,${senderImage}`}
                  src={process.env.PUBLIC_URL + '/img/user.png'}
                  alt={sender}
                  sx={{ width: 30, height: 30, borderRadius: 0 }}
                />
              </Grid>
              <Grid item>
                <Tooltip title={sender}>
                  <Typography sx={{ maxWidth: isSmallScreen ? '14ch' : 'none', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', fontWeight: 'bold' }}>
                    {sender}
                  </Typography>
                </Tooltip>
                <Tooltip title={senderDesignation}>
                  <Typography sx={{ maxWidth: isSmallScreen ? '14ch' : 'none', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {senderDesignation}
                  </Typography>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Box mt={1}>
          <StarRating value={rating} />
        </Box>

        <Typography sx={{ paddingTop: '4px' }}>
          Date : <span style={{ fontWeight: 'bold' }}>{createdDate}</span>
        </Typography>
        <Typography sx={{ paddingTop: '4px' }}>
          To which Project: <span style={{ fontWeight: 'bold' }}>{project}</span>
        </Typography>

        <Typography sx={{ paddingTop: '4px' }}>
          Summary: <span style={{ fontWeight: 'bold' }}>{category}</span>
        </Typography>
        {/* <Typography
                    sx={{
                        overflow: 'hidden',
                        display: '-webkit-box',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: isExpanded ? 'none' : 2,
                    }}
                >
                    Comment: <span style={{ fontStyle: 'italic' }}>"{description}"</span>
                </Typography>
                {description?.length > 100 && (
                    <Typography
                        variant="body2"
                        sx={{ color: 'blue', cursor: 'pointer', mt: 1 }}
                        onClick={onToggleExpand}
                    >
                        {isExpanded ? "See less" : "See more"}
                    </Typography>
                )} */}

        <Typography
          ref={commentRef}
          sx={{
            marginTop: '4px',
            overflow: "hidden",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: isExpanded ? "none" : 2,

          }}
        >
          Comment: <span style={{ fontStyle: "italic" }}> "{description}" </span>
        </Typography>
        {showSeeMore && (
          <Typography
            variant="body2"
            sx={{ color: "blue", cursor: "pointer", mt: 1 }}
            onClick={onToggleExpand}
          >
            {isExpanded ? "See less" : "See more"}
          </Typography>
        )}
      </CardContent>
      {status === "Y" && handleEditClick && (
        <Box textAlign="right" p={1}>
          <IconButton
            onClick={() => handleEditClick(editData)}
            color="primary"
            size="small"
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </Box>
      )}

    </Card>
  )
};


const FeedbackScreen = () => {
  const [filters, setFilters] = useState({
    receiver: null,
    sender: null,
    categoryId: null,
    fromDate: null,
    toDate: null
  });

  const [toggleFilter, setToggleFilter] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [feedbackData, setFeedbackData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(6);
  const [totalElements, setTotalElements] = useState(0);
  const [expandedComments, setExpandedComments] = useState({});
  const dispatch = useDispatch();
  const [taskOpen, setTaskOpen] = useState(false);
  const [editData, setEditData] = useState(null);

  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('');
  const [snackBarMessage, setSnackBarMessage] = useState('');

  const handleClearFilters = () => {
    setFilters({
      receiver: null,
      sender: null,
      categoryId: null,
      fromDate: null,
      toDate: null
    });
    handleReset();
    setCurrentPage(0);

  };


  const fetchFeedbackData = async (resetPage = false) => {
    try {
      dispatch(AppActions.showLoader());
      const body = {
        senders: filters.sender ? filters.sender.split(',').map(Number) : [],
        receivers: filters.receiver ? filters.receiver.split(',').map(Number) : [],
        datePeriod: filters.fromDate || filters.toDate ? {
          fromDate: filters.fromDate,
          toDate: filters.toDate
        } : null
      };
      const response = await getSendAndReceivedFeedbackSuperUser(
        rowsPerPage,
        resetPage ? 1 : currentPage + 1, // Use page 1 if resetPage is true
        filters.categoryId,
        body,
      );
      setFeedbackData(response.data.data.feedbackList);
      setTotalElements(response.data.data.totalElements);
      dispatch(AppActions.hideLoader());
    } catch (error) {
      console.error("Error fetching feedback data:", error);
      dispatch(AppActions.hideLoader());
    }
  };

  useEffect(() => {
    fetchFeedbackData();
  }, [currentPage, rowsPerPage, filters]);

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  const toggleExpandComment = (index) => {
    setExpandedComments((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const onSubmitToCreate = async (data: AddFeedback) => {

    try {
      dispatch(AppActions.showLoader());

      const response = await createFeedback(data);
      dispatch(AppActions.hideLoader());
      setSnackBarMessage('Your Feedback has been submitted successfully.');
      setSnackbarSeverity('success');
      setSnackBarOpen(true);
      setTaskOpen(!taskOpen);
      fetchFeedbackData();
    } catch (error) {
      setSnackBarMessage('Error creating feedback');
      setSnackbarSeverity('error');
      setSnackBarOpen(true);
      console.error('Error creating feedback:', error);
    }


  }

  const toggleTaskOpen = () => {
    setTaskOpen(!taskOpen);
  };

  const [dateChanged, setDateChanged] = useState(false);
  const [startDate, setStartDate] = useState<any>('');
  const [endDate, setEndDate] = useState<any>('');


  const dateStyle = {
    paddingTop: 7,
    fontSize: '12px',
  };

  const myRef = useRef<DateRangePicker>();

  const getInitSettings = () => {
    const today = new Date();
    let settings = {
      endDate: moment(today).format('MM/DD/YYYY'),
    };
    return settings;
  };

  const arrangeDate = (start: Date, end: Date) => {
    setDateChanged(true);
    const sDate = moment(start);
    const eDate = moment(end);
    setStartDate(sDate.format('YYYY-MM-DD'));
    setEndDate(eDate.format('YYYY-MM-DD'));
  };


  const handleReset = () => {
    const today = new Date();
    myRef.current?.setStartDate(moment(today).format('MM/DD/YYYY'));
    myRef.current?.setEndDate(moment(today).format('MM/DD/YYYY'));
    setStartDate('');
    setEndDate('');
    setDateChanged(false);

  };

  return (
    <Fragment>

      <Grid container sx={{ mt: 2, mb: 2 }} justifyContent="space-between">
        <Grid item>
          <Typography
            sx={{
              fontWeight: "700",
              fontSize: "16px",
              fontFamily: "Inter, Arial, sans-serif",
            }}
          >
            Feedbacks
          </Typography>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            startIcon={<AddTwoToneIcon fontSize="small" />}
            sx={{ height: "1.75rem", fontSize: "11px" }}
            onClick={() => {
              setEditData(null);
              setTaskOpen(true);
            }}
          >
            Add Feedback
          </Button>

        </Grid>
      </Grid>
      <Card>
        <Grid
          container
          style={{
            justifyContent: 'space-between',
            paddingTop: '1rem',
            paddingLeft: '1rem',
            paddingRight: '1rem',
            paddingBottom: '1rem'
          }}
          spacing={2}
        >
          <Grid item xs={6}>
            <Button
              id="btn-toggleFilter"
              sx={{
                mt: { xs: 2, md: 0 },
                color: `${!toggleFilter && 'gray'}`
              }}
              variant="outlined"
              startIcon={<FilterListIcon />}
              onClick={() => {
                setToggleFilter(!toggleFilter);
              }}
              style={{ height: '1.75rem', fontSize: '12px' }}
            >
              Filters
            </Button>
          </Grid>
        </Grid>
        {toggleFilter && (
          <Grid
            style={{
              justifyContent: 'space-between',
              paddingLeft: '1rem',
              paddingRight: '1rem',
              paddingBottom: '1rem'
            }}
          >
            <Grid>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={3}>


                  <SendReceiveSelectDropdown
                    label="Select Receiver"
                    value={filters.receiver}
                    isSender={false}
                    onChange={(e: any) => {
                      setFilters({
                        ...filters,
                        receiver: e
                      });
                      setCurrentPage(0);
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <SendReceiveSelectDropdown
                    label="Select Sender"
                    value={filters.sender}
                    isSender={true}
                    onChange={(e: any) => {
                      setFilters({
                        ...filters,
                        sender: e
                      });
                      setCurrentPage(0);
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <CategorySelectMultiselectDropdown
                    label="Category"
                    value={filters.categoryId}
                    onChange={(e: any) => {
                      setFilters({
                        ...filters,
                        categoryId: e
                      });
                      setCurrentPage(0);
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  {/* <SingleDatePicker
                                        fullWidth={false}
                                        label="Date of submit"
                                        value={filters.date}
                                        onChange={(e: any) => {
                                            setFilters({
                                                ...filters,
                                                date: e,
                                            });
                                        }}
                                    /> */}

                  <DateRangePicker
                    ref={myRef}
                    initialSettings={getInitSettings()}
                    onCallback={(start, end) => arrangeDate(start, end)}
                    onApply={(event, picker) => {
                      setFilters({
                        ...filters,
                        toDate: endDate,
                        fromDate: startDate
                      });
                      setCurrentPage(0);
                    }}
                    onCancel={() => {
                      handleReset();
                    }}
                  >
                    <div style={{ position: 'relative' }}>
                      <TextField
                        placeholder="Date range of submit"
                        value={
                          dateChanged
                            ? (startDate && startDate) +
                            ' - ' +
                            (endDate && endDate)
                            : ''
                        }
                        id="date"
                        fullWidth
                        size="small"
                        style={dateStyle}
                      />
                      <CalendarTodayIcon
                        className="calendar-icon"
                        fontSize={'small'}
                      />
                    </div>
                  </DateRangePicker>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              container
              style={{ justifyContent: 'flex-end', marginTop: 4 }}
              xs={12}
            >
              <Button
                id="btn-resetFilterResult"
                sx={{ mt: { xs: 2, md: 0 }, mr: 1 }}
                variant="outlined"
                onClick={handleClearFilters}
                className={isDisabled && 'clear-btn'}
                disabled={isDisabled}
                style={{ height: '1.75rem', fontSize: '12px' }}
              >
                Clear
              </Button>
              <Button
                id="btn-onSubmit"
                sx={{ mt: { xs: 2, md: 0 } }}
                disabled={isDisabled}
                variant="outlined"
                className={isDisabled && 'filter-btn'}
                type="submit"
                style={{ height: '1.75rem', fontSize: '12px' }}
                onClick={() => {
                  setCurrentPage(0); // Reset to first page
                  fetchFeedbackData(true); // Pass true to indicate page should be reset
                }}
              >
                Filter
              </Button>
            </Grid>
          </Grid>
        )}
        <Box p={2}>
          <Grid container spacing={2} mt={2}>
            {feedbackData.map((feedback, index) => (
              <Grid item xs={12} md={6} key={index}>
                <FeedbackCard
                  {...feedback}
                  isExpanded={expandedComments[index] || false}
                  onToggleExpand={() => toggleExpandComment(index)}
                  status={feedback.status}
                  editData={feedback}
                  handleEditClick={(data) => {
                    setEditData(data); // 🆕 this enables preview mode
                    setTaskOpen(true);
                  }}
                />

              </Grid>
            ))}
          </Grid>
        </Box>

        {feedbackData?.length === 0 && (
          <Typography
            style={{
              fontSize: '15px',
              fontWeight: 'bold',
              margin: '1rem',
              textAlign: 'center'
            }}
            variant="body2"
          >
            No Records Found
          </Typography>
        )}
        <Box p={2}>
          <TablePagination
            component="div"
            count={totalElements}
            page={currentPage}
            onPageChange={handlePageChange}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleRowsPerPageChange}
            rowsPerPageOptions={[6, 12, 18, 24, 30]}
            labelRowsPerPage="Rows per page"
          />
        </Box>
      </Card>

      <FeedbackModal
        open={taskOpen}
        toggle={toggleTaskOpen}
        onSave={onSubmitToCreate}
        editData={editData} // Will be null for "Add" and object for "Edit"
      />



      <SnackBar
        snackBarOpen={snackBarOpen}
        setSnackBarOpen={setSnackBarOpen}
        snackBarMessage={snackBarMessage}
        snackbarSeverity={snackbarSeverity}
      />
    </Fragment>
  );
};

export default FeedbackScreen;